const appConfig = {
  apiPrefix: '/api',
  authenticatedEntryPath: '/admin/consultas',
  unAuthenticatedEntryPath: '/sign-in',
  tourPath: '/',
  locale: 'en',
};

export default appConfig;
